module.exports = __webpack_public_path__ + "img/item4.881e7d9c.png";